<template>
  <Teleport to="body">
    <transition name="fade">
      <component
        :is="uiStore.getDynamicActionBar.component"
        v-bind="uiStore.getDynamicActionBar.data"
        v-model="uiStore.getDynamicActionBar.value"
        v-on="uiStore.getDynamicActionBar.events"
        @update:model-value="uiStore.cleanActionBar"
      />
    </transition>
  </Teleport>
</template>

<script setup lang="ts">
const uiStore = useUiStore()
</script>

<style scoped></style>
